<template>
    <div :style="`min-width:${barChartRankingArrecadacao.chartData.labels.length * 8}px;max-width:100%;`">
        <horizontalBar-chart id="bar-chart-ranking-arrecadao" :height="250" :chart-data="barChartRankingArrecadacao.chartData"
            :extra-options="barChartRankingArrecadacao.extraOptions">
        </horizontalBar-chart>
    </div>
</template>

<script>
const defaultObject = {
    chartData: {
        labels: [],
        datasets: [{
            label: 'Arrecadação no período',
            data: [],
            barThickness: 8,
            maxBarThickness: 30,
        }],
    },
    extraOptions: {
        legend: { display: false },
        tooltips: {
            callbacks: {
                label: (tooltipItem) => "R$ " + Number(tooltipItem.value).toFixed(2)
            }
        }
    }
}

import HorizontalBarChart from '@/components/Charts/HorizontalBarChart'

export default {
    component: 'BarChartRankingArrecadacao',

    components: {
        HorizontalBarChart,
    },

    props: {
        height: {
            type: Number,
            default: 250
        },

        defaultBarThickness: {
            type: Number,
            default: 8,
        },

        fetchProgress: {
            type: Number,
            default: 0 | 100
        },

        maxBarThickness: {
            type: Number,
            default: 30,
        },

        filteredDataCharts: {
            type: Array,
            default: [],
        },

        selectedbillItensNames: {
            type: Array,
            default: [],
        },

        verticalChartMaxLines: {
            type: Number,
            default: 20,
        },
    },

    data: () => {
        return {
            defaultChart: defaultObject,
        }
    },

    computed: {
        barChartRankingArrecadacao() {
            if(this.fetchProgress > 0 && this.fetchProgress < 100){
                this.defaultChart = defaultObject
                return this.defaultChart
            }

            else if(this.fetchProgress == 0 || this.fetchProgress == 100){
                const labels = [...new Set(this.groupBy(this.filteredDataCharts, val => val.poi).map(function (val, idx) { return val[0].product_name }) )]
                const arrayInfo = labels.map((label) => {
                    let totalCost = 0;
                    this.filteredDataCharts.forEach((val) => {
                        if (this.selectedbillItensNames.length <= 1 || this.selectedbillItensNames.includes(val.poi.product_name)) {
                            Object.values(val.itemPersonType).forEach(({ count, block_price }) => { totalCost += count * block_price; });
                        }
                    });
                    return { label, amount: totalCost };
                }).sort((a, b) => b.amount - a.amount);

                const arrayAmount = arrayInfo.slice(0, this.verticalChartMaxLines).map(({ amount }) => amount);
                const arrayLabels = arrayInfo.slice(0, this.verticalChartMaxLines).map(({ label }) => label);

                this.defaultChart.chartData = {
                    labels: arrayLabels,
                    datasets: [{
                        label: 'Arrecadação no período',
                        data: arrayAmount,
                        barThickness: this.defaultBarThickness,
                        maxBarThickness: this.maxBarThickness,
                    }],
                };

                this.defaultChart.extraOptions = {
                    legend: { display: false },
                    tooltips: {
                        callbacks: {
                            label: (tooltipItem) => "R$ " + Number(tooltipItem.value).toFixed(2)
                        }
                    }
                };

                return this.defaultChart
            }
        },
    },

    methods:{
        //METHOD TO GROUP BY KEYGETTER.
        //KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
        groupBy(list, keyGetter) {
            const map = new Map();
            list.forEach((item) => {
                const key = keyGetter(item);
                const collection = map.get(key);

                if (!collection) { map.set(key, [item]); }
                else { collection.push(item); }
            });
            return Array.from(map);
        },
    }
}
</script>   